import { ReactNode } from "react";
import "./self-employed-page-registration-data-item.sass";

type Props = {
  children: ReactNode;
};

const SelfEmployedFormPageRegistrationDataItem = ({ children }: Props) => {
  return (
    <div className="self-employed-page-registration-data-item">{children}</div>
  );
};

export default SelfEmployedFormPageRegistrationDataItem;
